import { ThirdPartyAssignmentItem } from "../../../interfaces/third-party-assignement-item.interface";

export const thirdPartiesFilterPredicate = (data: ThirdPartyAssignmentItem, filter: string): boolean => {
  const transformedFilter = filter.trim().toLowerCase();

  return data.organisationName.toLowerCase().includes(transformedFilter);
};
